/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { EventType } from './EventType';
import {
    EventTypeFromJSON,
    EventTypeFromJSONTyped,
    EventTypeToJSON,
    EventTypeToJSONTyped,
} from './EventType';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhotoAnalysisDecisionSource } from './PhotoAnalysisDecisionSource';
import {
    PhotoAnalysisDecisionSourceFromJSON,
    PhotoAnalysisDecisionSourceFromJSONTyped,
    PhotoAnalysisDecisionSourceToJSON,
    PhotoAnalysisDecisionSourceToJSONTyped,
} from './PhotoAnalysisDecisionSource';
import type { PhotoType } from './PhotoType';
import {
    PhotoTypeFromJSON,
    PhotoTypeFromJSONTyped,
    PhotoTypeToJSON,
    PhotoTypeToJSONTyped,
} from './PhotoType';
import type { AcceptanceCriteriaCondition } from './AcceptanceCriteriaCondition';
import {
    AcceptanceCriteriaConditionFromJSON,
    AcceptanceCriteriaConditionFromJSONTyped,
    AcceptanceCriteriaConditionToJSON,
    AcceptanceCriteriaConditionToJSONTyped,
} from './AcceptanceCriteriaCondition';

/**
 * 
 * @export
 * @interface GetPhotoSubmissionsItem
 */
export interface GetPhotoSubmissionsItem {
    /**
     * 
     * @type {string}
     * @memberof GetPhotoSubmissionsItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetPhotoSubmissionsItem
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GetPhotoSubmissionsItem
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoSubmissionsItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoSubmissionsItem
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoSubmissionsItem
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoSubmissionsItem
     */
    eventTypeId: string;
    /**
     * 
     * @type {PhotoType}
     * @memberof GetPhotoSubmissionsItem
     */
    photoType?: PhotoType;
    /**
     * 
     * @type {PhotoAnalysisDecisionSource}
     * @memberof GetPhotoSubmissionsItem
     */
    decisionSource?: PhotoAnalysisDecisionSource;
    /**
     * 
     * @type {Array<AcceptanceCriteriaCondition>}
     * @memberof GetPhotoSubmissionsItem
     */
    acceptanceCriteria?: Array<AcceptanceCriteriaCondition>;
    /**
     * Engine-dependent analysis payload. On the LLM path this is the Gemini verdict ({ pass, isScreenshot, isCallOfDuty, isWarzone, vehiclePresent, vehicleType, mapName }); on the cv_fallback path it is the Google Vision ImageAnalysisResult.
     * @type {object}
     * @memberof GetPhotoSubmissionsItem
     */
    analysisResults?: object;
    /**
     * 
     * @type {boolean}
     * @memberof GetPhotoSubmissionsItem
     */
    hasPassedAnalysis: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPhotoSubmissionsItem
     */
    hasPassedAdmin?: boolean;
    /**
     * Whether a brand operator has selected this passed photo for the public hub showcase carousel.
     * @type {boolean}
     * @memberof GetPhotoSubmissionsItem
     */
    showcaseIncluded?: boolean;
    /**
     * Order of this photo within the brand's showcase (lower = earlier). Only meaningful when showcaseIncluded is true.
     * @type {number}
     * @memberof GetPhotoSubmissionsItem
     */
    showcaseRank?: number;
    /**
     * 
     * @type {Asset}
     * @memberof GetPhotoSubmissionsItem
     */
    asset: Asset;
    /**
     * 
     * @type {User}
     * @memberof GetPhotoSubmissionsItem
     */
    user: User;
    /**
     * 
     * @type {EventType}
     * @memberof GetPhotoSubmissionsItem
     */
    eventType: EventType;
}



/**
 * Check if a given object implements the GetPhotoSubmissionsItem interface.
 */
export function instanceOfGetPhotoSubmissionsItem(value: object): value is GetPhotoSubmissionsItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('eventTypeId' in value) || value['eventTypeId'] === undefined) return false;
    if (!('hasPassedAnalysis' in value) || value['hasPassedAnalysis'] === undefined) return false;
    if (!('asset' in value) || value['asset'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function GetPhotoSubmissionsItemFromJSON(json: any): GetPhotoSubmissionsItem {
    return GetPhotoSubmissionsItemFromJSONTyped(json, false);
}

export function GetPhotoSubmissionsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPhotoSubmissionsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': json['userId'],
        'assetId': json['assetId'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'eventTypeId': json['eventTypeId'],
        'photoType': json['photoType'] == null ? undefined : PhotoTypeFromJSON(json['photoType']),
        'decisionSource': json['decisionSource'] == null ? undefined : PhotoAnalysisDecisionSourceFromJSON(json['decisionSource']),
        'acceptanceCriteria': json['acceptanceCriteria'] == null ? undefined : ((json['acceptanceCriteria'] as Array<any>).map(AcceptanceCriteriaConditionFromJSON)),
        'analysisResults': json['analysisResults'] == null ? undefined : json['analysisResults'],
        'hasPassedAnalysis': json['hasPassedAnalysis'],
        'hasPassedAdmin': json['hasPassedAdmin'] == null ? undefined : json['hasPassedAdmin'],
        'showcaseIncluded': json['showcaseIncluded'] == null ? undefined : json['showcaseIncluded'],
        'showcaseRank': json['showcaseRank'] == null ? undefined : json['showcaseRank'],
        'asset': AssetFromJSON(json['asset']),
        'user': UserFromJSON(json['user']),
        'eventType': EventTypeFromJSON(json['eventType']),
    };
}

export function GetPhotoSubmissionsItemToJSON(json: any): GetPhotoSubmissionsItem {
    return GetPhotoSubmissionsItemToJSONTyped(json, false);
}

export function GetPhotoSubmissionsItemToJSONTyped(value?: GetPhotoSubmissionsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'userId': value['userId'],
        'assetId': value['assetId'],
        'gameId': value['gameId'],
        'eventTypeId': value['eventTypeId'],
        'photoType': PhotoTypeToJSON(value['photoType']),
        'decisionSource': PhotoAnalysisDecisionSourceToJSON(value['decisionSource']),
        'acceptanceCriteria': value['acceptanceCriteria'] == null ? undefined : ((value['acceptanceCriteria'] as Array<any>).map(AcceptanceCriteriaConditionToJSON)),
        'analysisResults': value['analysisResults'],
        'hasPassedAnalysis': value['hasPassedAnalysis'],
        'hasPassedAdmin': value['hasPassedAdmin'],
        'showcaseIncluded': value['showcaseIncluded'],
        'showcaseRank': value['showcaseRank'],
        'asset': AssetToJSON(value['asset']),
        'user': UserToJSON(value['user']),
        'eventType': EventTypeToJSON(value['eventType']),
    };
}

